/* Rumbo · web heyrumbo.com: menú, botón de descarga por sistema, demo, pestañas, planes, lista de espera y SmartScreen. */
(function () {
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); };

  /* Sistema: windows, mac, movil u otro */
  var ua = navigator.userAgent || '';
  var so = /Android|iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'movil'
    : /Windows/i.test(ua) ? 'windows' : /Mac OS X|Macintosh/i.test(ua) ? 'mac' : 'otro';
  document.documentElement.dataset.so = so;
  $$('[data-descargar]').forEach(function (b) {
    if (so === 'windows') return;
    b.href = b.dataset.pagina;
    b.dataset.so = 'otro';
    var t = b.querySelector('[data-texto]');
    if (t) t.textContent = b.dataset.otro;
  });
  $$('[data-sistema="' + so + '"]').forEach(function (s) { s.classList.add('actual'); });

  /* Menú del móvil */
  var boton = document.getElementById('botonMenu');
  var menu = document.getElementById('menuMovil');
  if (boton && menu) {
    var cerrar = function () {
      boton.setAttribute('aria-expanded', 'false');
      boton.setAttribute('aria-label', boton.dataset.abrir);
      menu.classList.remove('abierto');
      document.documentElement.classList.remove('sin-scroll');
      setTimeout(function () { if (!menu.classList.contains('abierto')) menu.hidden = true; }, 300);
    };
    boton.addEventListener('click', function () {
      if (boton.getAttribute('aria-expanded') === 'true') return cerrar();
      menu.hidden = false;
      requestAnimationFrame(function () { menu.classList.add('abierto'); });
      boton.setAttribute('aria-expanded', 'true');
      boton.setAttribute('aria-label', boton.dataset.cerrar);
      document.documentElement.classList.add('sin-scroll');
    });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) cerrar(); });
  }

  /* Aparecer al entrar en pantalla */
  var ver = $$('[data-ver]');
  if ('IntersectionObserver' in window && !quieto) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    ver.forEach(function (el) { io.observe(el); });
  } else {
    ver.forEach(function (el) { el.classList.add('visto'); });
  }

  /* Bucle por fases, solo mientras se ve */
  function bucle(el, tiempos, alFase) {
    var fase = 0, reloj = null, activo = false;
    var siguiente = function () {
      fase = (fase + 1) % tiempos.length;
      el.dataset.fase = fase;
      if (alFase) alFase(fase);
      reloj = setTimeout(siguiente, tiempos[fase]);
    };
    var poner = function (si) {
      if (si === activo) return;
      activo = si;
      if (si) reloj = setTimeout(siguiente, tiempos[fase]);
      else clearTimeout(reloj);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { poner(es[0].isIntersecting); }).observe(el);
    } else poner(true);
  }

  /* Demo de la portada: caos → etiquetas → calculando → resumen */
  $$('[data-demo]').forEach(function (d) {
    if (quieto) { d.dataset.fase = 3; return; }
    bucle(d, [1600, 2800, 1300, 4200]);
  });

  /* SmartScreen en la página de gracias */
  $$('[data-smart]').forEach(function (s) {
    var mas = s.querySelector('.smart__mas');
    var ventana = s.querySelector('.smart__ventana');
    var medir = function () { if (mas && ventana) s.style.setProperty('--y-mas', (mas.offsetTop + 4) + 'px'); };
    medir();
    window.addEventListener('resize', medir);
    if (quieto) { s.dataset.fase = 2; return; }
    bucle(s, [1400, 1500, 1500, 1800], function (f) {
      if (f === 2 || f === 3) { s.classList.add('clic'); setTimeout(function () { s.classList.remove('clic'); }, 180); }
    });
  });

  /* Pestañas con teclado */
  $$('[data-pestanas]').forEach(function (caja) {
    var tabs = $$('[role="tab"]', caja);
    var elegir = function (t, foco) {
      tabs.forEach(function (o) {
        var si = o === t;
        o.setAttribute('aria-selected', si);
        o.tabIndex = si ? 0 : -1;
        document.getElementById(o.getAttribute('aria-controls')).hidden = !si;
      });
      if (foco) t.focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { elegir(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); elegir(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
  });

  /* Mensual o anual */
  $$('[data-periodo]').forEach(function (g) {
    var botones = $$('button', g);
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.valor;
        botones.forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
        $$('[data-solo]').forEach(function (el) { el.hidden = el.dataset.solo !== v; });
        $$('[data-comprar]').forEach(function (a) { a.href = v === 'anio' ? a.dataset.anio : a.dataset.mes; });
      });
    });
  });

  /* Lo que se desbloquea en cada plan */
  $$('[data-desbloqueo]').forEach(function (caja) {
    var botones = $$('[data-nivel]', caja);
    var items = $$('li[data-n]', caja);
    var poner = function (n) {
      caja.dataset.plan = n;
      botones.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.nivel === n); });
      items.forEach(function (li) {
        var m = +li.dataset.n, p = +n;
                var abierto = m <= p;
        li.classList.toggle('cerrado', !abierto);
      });
    };
    botones.forEach(function (b) { b.addEventListener('click', function () { poner(b.dataset.nivel); }); });
    poner('1');
  });

  /* Lista de espera: une las opciones en las etiquetas del cliente, con el idioma y el origen.
     El origen se calcula al enviar (utm_source de la URL actual o, si no hay, el sitio de document.referrer) y no se guarda nada en el navegador (LSSI, art. 22.2). */
  var limpio = function (t) { return String(t || '').toLowerCase().replace(/^www\./, '').replace(/[^a-z0-9.-]+/g, '-').slice(0, 40); };
  var calcularOrigen = function () {
    var qs = '', ref = '';
    try { qs = new URLSearchParams(location.search).get('utm_source') || ''; } catch (e) {}
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (ref === location.hostname) ref = '';
    return limpio(qs) || limpio(ref) || 'directo';
  };
  /* La versión anterior guardaba el origen en el navegador: se borra lo que haya quedado */
  try { localStorage.removeItem('rumbo-origen'); } catch (e) {}
  try { sessionStorage.removeItem('rumbo-origen'); } catch (e) {}
  $$('[data-espera]').forEach(function (f) {
    var campo = f.querySelector('[data-etiquetas]');
    if (!campo) return;
    var idioma = limpio(document.documentElement.lang || 'es');
    var cIdioma = f.querySelector('[data-idioma]'), cOrigen = f.querySelector('[data-origen]');
    if (cIdioma) cIdioma.value = idioma;
    f.addEventListener('submit', function () {
      var origen = calcularOrigen();
      if (cOrigen) cOrigen.value = origen;
      var marcadas = $$('[data-opcion]:checked', f).map(function (c) { return c.value; });
      campo.value = ['lista-espera'].concat(marcadas, campo.dataset.extra ? [campo.dataset.extra] : [], ['idioma-' + idioma, 'origen-' + origen]).join(',');
    });
  });
  try {
    var pedido = new URLSearchParams(location.search).get('apuntar');
    var marcar = pedido && document.querySelector('#lista [data-opcion="' + limpio(pedido) + '"]');
    if (marcar) marcar.checked = true;
  } catch (e) {}
  $$('[data-apuntar]').forEach(function (a) {
    a.addEventListener('click', function () {
      var c = document.querySelector('#lista [data-opcion="' + a.dataset.apuntar + '"]');
      if (c) c.checked = true;
      setTimeout(function () { var i = document.getElementById('espera-correo'); if (i) i.focus({ preventScroll: true }); }, 600);
    });
  });

  /* Gracias: empieza la descarga sola */
  $$('[data-gracias]').forEach(function (g) {
    var urls = {}; try { urls = JSON.parse(g.dataset.urls || '{}'); } catch (e) {}
    var q = new URLSearchParams(location.search), idioma = q.get('idioma') || 'es';
    var url = urls[idioma] || '';
    var manual = g.querySelector('[data-enlace-manual]'); if (manual && url) manual.href = url;
    if (!url || so !== 'windows' || q.get('so') === 'mac') return;
    setTimeout(function () { window.location.href = url; }, 1200);
  });

  /* Idiomas: capa con el mapamundi, cambio suave y aviso si el navegador habla otro idioma */
  var capa = document.getElementById('capaIdiomas');
  if (capa) {
    var ultimo = null;
    var abrirCapa = function (e) {
      ultimo = e && e.currentTarget;
      capa.hidden = false;
      requestAnimationFrame(function () { capa.classList.add('abierta'); });
      document.documentElement.classList.add('sin-scroll');
      var f = capa.querySelector('.idiomas__opcion--actual') || capa.querySelector('button.idiomas__opcion');
      if (f) f.focus();
    };
    var cerrarCapa = function () {
      capa.classList.remove('abierta');
      document.documentElement.classList.remove('sin-scroll');
      setTimeout(function () { capa.hidden = true; }, quieto ? 0 : 350);
      if (ultimo) ultimo.focus();
    };
    $$('[data-abrir-idiomas]').forEach(function (b) { b.addEventListener('click', abrirCapa); });
    $$('[data-cerrar-idiomas]', capa).forEach(function (b) { b.addEventListener('click', cerrarCapa); });
    capa.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') return cerrarCapa();
      if (e.key !== 'Tab') return;
      var f = $$('button:not([disabled]), a[href]', capa);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    /* El punto del mapa y su fila de la lista se iluminan juntos; pulsar el punto elige el idioma */
    $$('.mapa__idioma', capa).forEach(function (pt) {
      var op = capa.querySelector('button.idiomas__opcion[data-idioma="' + pt.dataset.idioma + '"]');
      if (!op) return;
      var on = function (v) { pt.classList.toggle('encendido', v); op.classList.toggle('encendido', v); };
      pt.addEventListener('mouseenter', function () { on(true); });
      pt.addEventListener('mouseleave', function () { on(false); });
      op.addEventListener('mouseenter', function () { on(true); });
      op.addEventListener('mouseleave', function () { on(false); });
      op.addEventListener('focus', function () { on(true); });
      op.addEventListener('blur', function () { on(false); });
      pt.addEventListener('click', function () { op.click(); });
    });
    $$('form', capa).concat($$('#sugerenciaIdioma form')).forEach(function (f) {
      f.addEventListener('submit', function () { document.documentElement.classList.add('cambiando-idioma'); });
    });
  }
  var sug = document.getElementById('sugerenciaIdioma');
  var datos = document.getElementById('idiomasDatos');
  if (sug && datos) {
    try {
      var d = JSON.parse(datos.textContent), visto = null;
      try { visto = localStorage.getItem('rumboIdiomaVisto'); } catch (e) {}
      var pide = (navigator.languages || [navigator.language || '']).map(function (l) { return String(l).toLowerCase(); });
      var elegir = null;
      pide.some(function (l) {
        elegir = d.disponibles.filter(function (x) { return x.c.toLowerCase() === l; })[0] ||
          d.disponibles.filter(function (x) { return x.c.toLowerCase().split('-')[0] === l.split('-')[0]; })[0] || null;
        return !!elegir;
      });
      if (elegir && elegir.c !== d.actual && visto !== d.actual) {
        sug.querySelector('[data-sugerencia-texto]').textContent += ' ' + elegir.n;
        var bt = sug.querySelector('[data-sugerencia-boton]');
        bt.value = elegir.c;
        bt.querySelector('span').textContent += ' ' + elegir.n;
        sug.hidden = false;
        requestAnimationFrame(function () { sug.classList.add('visible'); });
      }
      sug.querySelector('[data-sugerencia-no]').addEventListener('click', function () {
        try { localStorage.setItem('rumboIdiomaVisto', d.actual); } catch (e) {}
        sug.classList.remove('visible');
        setTimeout(function () { sug.hidden = true; }, 400);
      });
    } catch (e) {}
  }

  /* Maquetas 3D: se inclinan con el ratón (solo ordenador y sin «reducir movimiento») */
  var fino = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)').matches;
  if (fino && !quieto) {
    $$('[data-inclinar]').forEach(function (m) {
      var cuerpo = m.querySelector('.maqueta__cuerpo'), pend = false, ex = 0, ey = 0;
      if (!cuerpo) return;
      m.addEventListener('pointermove', function (e) {
        var r = m.getBoundingClientRect();
        ex = (e.clientX - r.left) / r.width - 0.5; ey = (e.clientY - r.top) / r.height - 0.5;
        if (pend) return; pend = true;
        requestAnimationFrame(function () {
          pend = false;
          cuerpo.style.setProperty('--ry', (ex * 8).toFixed(2) + 'deg');
          cuerpo.style.setProperty('--rx', (-ey * 6).toFixed(2) + 'deg');
        });
      });
      m.addEventListener('pointerleave', function () { cuerpo.style.setProperty('--ry', '0deg'); cuerpo.style.setProperty('--rx', '0deg'); });
    });
  }

  /* Menú desplegable de Planes */
  $$('[data-desplegable]').forEach(function (d) {
    var b = d.querySelector('button'), t = null;
    var poner = function (v) { d.classList.toggle('abierto', v); b.setAttribute('aria-expanded', v); };
    b.addEventListener('click', function () { poner(!d.classList.contains('abierto')); });
    d.addEventListener('mouseenter', function () { clearTimeout(t); poner(true); });
    d.addEventListener('mouseleave', function () { t = setTimeout(function () { poner(false); }, 160); });
    d.addEventListener('focusout', function (e) { if (!d.contains(e.relatedTarget)) poner(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { poner(false); b.focus(); } });
  });

  /* Preguntas: se abren y se cierran con la misma animación (altura y opacidad, 330 ms). El atributo open se quita al terminar de cerrar;
     el icono gira a la vez con la clase «abierta», y si se pulsa a medias la animación sigue desde la altura en la que está. */
  $$('.acordeon details').forEach(function (det) {
    var sum = det.querySelector('summary'), resp = det.querySelector('.acordeon__resp'), anim = null;
    if (!sum || !resp) return;
    det.classList.toggle('abierta', det.open);
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      var abrir = !det.classList.contains('abierta');
      det.classList.toggle('abierta', abrir);
      if (quieto || !('animate' in resp)) { det.open = abrir; return; }
      var desde = det.open ? resp.getBoundingClientRect().height : 0, opDesde = anim ? +getComputedStyle(resp).opacity : (det.open ? 1 : 0);
      if (anim) anim.cancel();
      det.open = true;
      var hasta = abrir ? resp.scrollHeight : 0;
      anim = resp.animate([{ height: desde + 'px', opacity: opDesde }, { height: hasta + 'px', opacity: abrir ? 1 : 0 }], { duration: 330, easing: 'cubic-bezier(.32,.72,0,1)' });
      anim.onfinish = function () { anim = null; if (!abrir) det.open = false; };
    });
  });

  /* Descargar: «¿De qué team eres?». Windows va a Gracias (un solo instalador); Mac abre su panel */
  $$('[data-descarga]').forEach(function (z) {
    var movil = z.querySelector('[data-solo-movil]');
    if (movil && so === 'movil') movil.hidden = false;
    var guino = function (t) {
      var ok = t.querySelector('.team__ok'); ok.textContent = ok.dataset.ok;
      if (!quieto) { t.classList.remove('salta'); void t.offsetWidth; t.classList.add('salta'); }
    };
    $$('[data-team]', z).forEach(function (t) {
      if (t.dataset.team === so) t.classList.add('tuyo');
      if (t.hasAttribute('data-ir')) {
        t.addEventListener('click', function (e) {
          e.preventDefault(); t.classList.add('elegido'); guino(t);
          setTimeout(function () { location.href = t.href; }, quieto ? 0 : 750);
        });
      } else if (t.hasAttribute('aria-controls')) {
        t.addEventListener('click', function () {
          var p = document.getElementById(t.getAttribute('aria-controls')), abre = p.hidden;
          t.setAttribute('aria-expanded', abre); t.classList.toggle('elegido', abre);
          if (abre) { guino(t); p.hidden = false; requestAnimationFrame(function () { p.classList.add('abierto'); }); }
          else { p.classList.remove('abierto'); p.hidden = true; }
        });
      }
    });
  });
  /* Lista de espera con una etiqueta extra (idioma de la app, enviar el enlace…) */
  $$('[data-extra]').forEach(function (a) {
    a.addEventListener('click', function () {
      var f = document.querySelector('#lista [data-etiquetas]');
      if (f) f.dataset.extra = a.dataset.extra;
    });
  });

  /* Indicador de plan: se ve entre la entrada de Básica y la de «Lo que viene»; enciende el plan en el que estás y una línea de progreso */
  $$('[data-zonas]').forEach(function (nav) {
    var marcas = ['basica', 'pro', 'ultra', 'ia'].map(function (z) { return document.getElementById('bloque-' + z); });
    if (marcas.some(function (m) { return !m; })) return;
    nav.hidden = false;
    var enlaces = $$('[data-zona-ir]', nav), barra = nav.querySelector('.zonas__linea b'), tops = [], medidoZ = 0, pend = false, actual = '';
    var medir = function () { medidoZ = Date.now(); tops = marcas.map(function (m) { return m.getBoundingClientRect().top + window.scrollY; }); };
    var pintar = function () {
      pend = false;
      if (Date.now() - medidoZ > 800) medir();
      var y = window.scrollY + window.innerHeight * .5, i = -1;
      for (var k = 0; k < 3; k++) if (y >= tops[k]) i = k;
      var dentro = i >= 0 && y < tops[3];
      nav.classList.toggle('zonas--ver', dentro);
      var z = dentro ? ['basica', 'pro', 'ultra'][i] : '';
      if (z !== actual) { actual = z; nav.dataset.actual = z; enlaces.forEach(function (a) { a.classList.toggle('activo', a.dataset.zonaIr === z); if (a.dataset.zonaIr === z) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }); }
      barra.style.transform = 'scaleX(' + Math.min(1, Math.max(0, (y - tops[0]) / (tops[3] - tops[0]))).toFixed(4) + ')';
    };
    window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(pintar); } }, { passive: true });
    window.addEventListener('resize', function () { medir(); pintar(); });
    window.addEventListener('load', function () { medir(); pintar(); });
    medir(); pintar();
  });

  /* Problemas reales: al tocar una tarjeta se queda girada (en el ratón basta con pasar por encima, con CSS) */
  $$('[data-problemas] .problema').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); });
  });

  /* Motor de escenas con scroll: el progreso real (objetivo) se sigue con un muelle (lerp) por fotograma, para que todo se mueva con inercia,
     también con la rueda del ratón. Las medidas se guardan y solo se renuevan al cargar, al cambiar el tamaño o cada medio segundo de scroll. */
  var escenas = [], motorVivo = false, FACTOR = 0.1, medido = 0;
  var limitar = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var medirTodo = function () { medido = Date.now(); escenas.forEach(function (e) { e.medir(); e.ult = -1; }); };
  var bucle = function () {
    var y = window.scrollY, vh = window.innerHeight, sigue = false;
    escenas.forEach(function (e) {
      /* Dentro o fuera se decide con las medidas guardadas, sin leer el diseño en cada fotograma */
      var dentro = y + vh > e.arriba - 300 && y < e.abajo + 300;
      if (dentro !== e.dentro) {
        e.dentro = dentro;
        e.el.classList.toggle('en-vista', dentro);
        /* Al entrar de golpe (enlace o salto), empieza donde toca, sin recorrer todo */
        if (dentro && Math.abs(limitar((y - e.ini) / e.largo) - e.p) > 0.25) e.p = limitar((y - e.ini) / e.largo);
      }
      if (!dentro) return;
      var obj = limitar((y - e.ini) / e.largo);
      e.p += (obj - e.p) * FACTOR;
      if (Math.abs(obj - e.p) < 0.0004) e.p = obj; else sigue = true;
      if (e.p !== e.ult) { e.ult = e.p; e.pintar(e.p); }
    });
    if (sigue) requestAnimationFrame(bucle); else motorVivo = false;
  };
  var arrancar = function () {
    if (Date.now() - medido > 500) medirTodo();
    if (!motorVivo) { motorVivo = true; requestAnimationFrame(bucle); }
  };
  var escena = function (el, pista, pintar, opc) {
    opc = opc || {};
    var e = { el: el, pintar: pintar, p: 0, ult: -1, dentro: false };
    e.medir = function () {
      var r = pista.getBoundingClientRect(), vh = window.innerHeight, y = window.scrollY;
      e.arriba = r.top + y; e.abajo = r.bottom + y;
      e.ini = e.arriba + (opc.desde ? opc.desde(vh) : 0);
      e.largo = Math.max(1, opc.largo ? opc.largo(r, vh) : r.height - vh);
      if (opc.alMedir) opc.alMedir();
    };
    /* Imágenes ya decodificadas antes de llegar */
    var cargar = function () {
      el.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); });
    };
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { o.disconnect(); cargar(); } }, { rootMargin: '900px 0px' }).observe(el);
    else cargar();
    escenas.push(e);
    e.medir(); pintar(0);
    return e;
  };
  window.addEventListener('scroll', arrancar, { passive: true });
  window.addEventListener('resize', function () { medirTodo(); arrancar(); });
  window.addEventListener('load', function () { medirTodo(); arrancar(); });
  setTimeout(arrancar, 0);
  var suave = function (t) { t = limitar(t); return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var rebote = function (t) { t = limitar(t); var c1 = 1.2, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };

  /* Rumbo en acción (3D): una cámara recorre la app. Cada pieza tiene sus fotogramas clave (p de 0 a 1). */
  $$('[data-cine]').forEach(function (c) {
    if (quieto || !window.matchMedia('(min-width: 901px)').matches) return;
    c.classList.add('cine--3d');
    requestAnimationFrame(function () { requestAnimationFrame(function () { c.classList.add('cine--listo'); }); });
    var pista = c.querySelector('.cine__pista'), pasos = $$('.cine__paso', c), cursor = c.querySelector('[data-k="cursor"]');
    var zona = c.querySelector('.cine__pantallas'), fondo = c.querySelector('.cine__fondo'), sombra = c.querySelector('.cine__sombra');
    var pisos = $$('.cine__piso', c), planta = c.querySelector('[data-planta]'), hueco = c.querySelector('.cine__hueco i'), velocidad = [22, 48, 90];
    var K = {
      camara: [[0, { rx: 38, ry: -28, s: .62, y: 6, z: -200, o: 0 }], [.06, { o: 1 }], [.14, { rx: 6, ry: 0, s: 1, y: 0, z: 0 }], [.18, {}], [.26, { s: 1.75, x: 17, y: 11 }], [.31, {}], [.35, { s: 1, x: 0, y: 0 }], [.45, { s: 1.12, y: -2 }],
        [.51, { rx: 34, rz: -9, s: .9, y: 3 }], [.63, {}], [.68, { rx: 6, rz: 0, s: 1, y: 0 }], [.79, { rx: 8, ry: 16, s: .94, x: -7 }], [.85, { ry: 0, x: 0, s: 1.08 }], [1, { rx: 4, s: 1.2, y: -3 }]],
      pantalla0: [[0, { o: 1 }], [.2, { o: 1 }], [.205, { o: 0 }]],
      pantalla1: [[0, { o: 0 }], [.15, { o: 0, s: 1.025 }], [.2, { o: 1, s: 1 }], [.38, { o: 1 }], [.385, { o: 0 }]],
      pantalla2: [[0, { o: 0 }], [.33, { o: 0, s: 1.025 }], [.38, { o: 1, s: 1 }], [.47, { o: 1 }], [.52, { o: 0 }]],
      pantalla3: [[0, { o: 0 }], [.48, { o: 0 }], [.52, { o: .25 }], [.65, { o: .25 }], [.69, { o: 0 }]],
      pantalla4: [[0, { o: 0 }], [.65, { o: 0, s: 1.025 }], [.7, { o: 1, s: 1 }], [.88, { o: 1 }], [.885, { o: 0 }]],
      pantalla5: [[0, { o: 0 }], [.83, { o: 0, s: 1.025 }], [.88, { o: 1, s: 1 }], [1, { o: 1 }]],
      etq0: [[0, { o: 0, z: 50 }], [.56, { o: 0, z: 50 }], [.58, { o: 1, z: 50 }], [.63, { o: 1, z: 50 }], [.65, { o: 0, z: 50 }]],
      etq1: [[0, { o: 0, z: 90 }], [.56, { o: 0, z: 90 }], [.58, { o: 1, z: 90 }], [.63, { o: 1, z: 90 }], [.65, { o: 0, z: 90 }]],
      etq2: [[0, { o: 0, z: 135 }], [.56, { o: 0, z: 135 }], [.58, { o: 1, z: 135 }], [.63, { o: 1, z: 135 }], [.65, { o: 0, z: 135 }]],
      etq3: [[0, { o: 0, z: 180 }], [.56, { o: 0, z: 180 }], [.58, { o: 1, z: 180 }], [.63, { o: 1, z: 180 }], [.65, { o: 0, z: 180 }]],
      pop0: [[0, { o: 0, y: 6, z: -120, s: .8 }], [.69, { o: 0, y: 6, z: -120, s: .8 }], [.74, { o: 1, y: 0, z: 140, s: 1 }], [.85, { o: 1, y: -1 }], [.89, { o: 0, y: -4 }]],
      pop1: [[0, { o: 0, y: 6, z: -120, s: .8 }], [.74, { o: 0, y: 6, z: -120, s: .8 }], [.79, { o: 1, y: 0, z: 200, s: 1 }], [.87, { o: 1 }], [.91, { o: 0, y: -4 }]],
      cursor: [[0, { o: 0, cx: 62, cy: 42 }], [.1, { o: 0, cx: 62, cy: 42 }], [.13, { o: 1, cx: 50, cy: 48 }], [.22, { cx: 28, cy: 26 }], [.3, { cx: 30, cy: 27 }], [.4, { cx: 70, cy: 58 }], [.47, { o: 1 }], [.49, { o: 0 }],
        [.86, { o: 0, cx: 40, cy: 44 }], [.9, { o: 1, cx: 42, cy: 44 }], [.96, { cx: 62, cy: 56 }], [1, { o: 1, cx: 63, cy: 57 }]]
    };
    $$('.cine__capa', c).forEach(function (el, n) {
      var z = (+el.dataset.z || 100) * .55, d = n * .004;
      K['capa' + n] = [[0, { o: 0, z: 0 }], [.48 + d, { o: 0, z: 0 }], [.51 + d, { o: 1, z: 0 }], [.58 + d, { z: z }], [.63, { z: z }], [.68, { z: 0, o: 1 }], [.7, { o: 0, z: 0 }]];
    });
    var clics = [[.22, .25], [.95, .98]];
    var base = { x: 0, y: 0, z: 0, rx: 0, ry: 0, rz: 0, s: 1, o: 1, d: 0, cx: 0, cy: 0 };
    Object.keys(K).forEach(function (k) {
      var prev = Object.assign({}, base);
      K[k] = K[k].map(function (f) { prev = Object.assign({}, prev, f[1]); return [f[0], prev]; });
    });
    var valor = function (frames, p, curva) {
      if (p <= frames[0][0]) return frames[0][1];
      for (var i = 1; i < frames.length; i++) {
        if (p <= frames[i][0]) {
          var a = frames[i - 1], b = frames[i], t = curva((p - a[0]) / (b[0] - a[0] || 1)), r = {};
          for (var q in b[1]) r[q] = a[1][q] + (b[1][q] - a[1][q]) * t;
          return r;
        }
      }
      return frames[frames.length - 1][1];
    };
    var piezas = {}, claves;
    $$('[data-k]', c).forEach(function (el) { piezas[el.dataset.k] = el; });
    claves = Object.keys(K).filter(function (k) { return piezas[k]; });
    var zw = 1, zh = 1, activo = -1;
    escena(c, pista, function (p) {
      /* Llegada a cada planta: cerca del cambio de paso el portátil baja un poco y se atenúa, y vuelve a subir en la planta nueva */
      var cerca = 0;
      for (var b = 1; b < pasos.length; b++) cerca = Math.max(cerca, 1 - Math.min(1, Math.abs(p - b / pasos.length) / .04));
      cerca = suave(cerca);
      for (var n = 0; n < claves.length; n++) {
        var k = claves[n], el = piezas[k], v = valor(K[k], p, k === 'camara' ? rebote : suave);
        if (k === 'camara') { v = Object.assign({}, v); v.y += 6 * cerca; v.o *= 1 - .55 * cerca; }
        if (k === 'cursor') el.style.transform = 'translate3d(' + (v.cx / 100 * zw).toFixed(1) + 'px,' + (v.cy / 100 * zh).toFixed(1) + 'px,40px)';
        else el.style.transform = 'translate3d(' + v.x.toFixed(2) + 'vw,' + v.y.toFixed(2) + 'vh,' + v.z.toFixed(1) + 'px) rotateX(' + v.rx.toFixed(2) + 'deg) rotateY(' + v.ry.toFixed(2) + 'deg) rotateZ(' + v.rz.toFixed(2) + 'deg) scale(' + v.s.toFixed(3) + ')';
        el.style.opacity = v.o.toFixed(3);
        if (k === 'camara' && sombra) sombra.style.opacity = (.35 + .65 * (1 - Math.min(1, Math.abs(v.rx) / 55))).toFixed(3);
      }
      /* Parallax: el fondo va más despacio que el portátil */
      if (fondo) fondo.style.transform = 'translate3d(0,' + (-p * 14).toFixed(2) + 'vh,0) scale(1.1)';
      /* Parallax inverso: al bajar, las capas bajan (cada una a su velocidad) y la cámara parece subir */
      for (var q = 0; q < pisos.length; q++) pisos[q].style.transform = 'translate3d(0,' + (p * velocidad[q]).toFixed(2) + 'vh,0)';
      if (hueco) hueco.style.transform = 'scaleY(' + p.toFixed(4) + ')';
      c.style.setProperty('--p', p.toFixed(4));
      cursor.classList.toggle('pulsa', clics.some(function (x) { return p >= x[0] && p <= x[1]; }));
      /* El texto del paso siguiente entra un poco antes de que acabe el anterior */
      var i = Math.min(pasos.length - 1, Math.floor(p * pasos.length + .06));
      if (i !== activo) { activo = i; pasos.forEach(function (s, m) { s.classList.toggle('activo', m === i); }); if (planta) planta.textContent = i + 1; }
    }, { alMedir: function () { zw = zona.offsetWidth; zh = zona.offsetHeight; } });
  });

  /* Mi camino en 3D: un solo progreso; cada tramo enciende a la vez su texto y su parada, y vuelve atrás igual al subir */
  $$('[data-camino3d]').forEach(function (c) {
    var pasos = $$('.camino3d__paso', c), marcas = $$('[data-marca]', c);
    var camara = c.querySelector('[data-c="camara"]'), nivel = c.querySelector('[data-c="nivel"]'), logro = c.querySelector('[data-c="logro"]');
    var N = pasos.length;
    if (quieto || !window.matchMedia('(min-width: 901px)').matches) {
      pasos.forEach(function (s) { s.classList.add('hecho'); }); marcas.forEach(function (m) { m.classList.add('hecha'); });
      c.classList.add('camino3d--fin'); return;
    }
    c.classList.add('camino3d--3d');
    var activo = -1;
    escena(c, c.querySelector('.camino3d__pista'), function (p) {
      c.style.setProperty('--p', p.toFixed(4));
      var i = Math.min(N - 1, Math.floor(p * N)), local = p * N - i;
      if (i !== activo) {
        activo = i;
        pasos.forEach(function (s, k) { s.classList.toggle('activo', k === i); s.classList.toggle('hecho', k < i); });
        marcas.forEach(function (m, k) { m.classList.toggle('hecha', k <= i); m.classList.toggle('ahora', k === i); });
      }
      var entra = rebote(p * N);
      camara.style.transform = 'rotateX(' + (22 - 16 * entra).toFixed(2) + 'deg) rotateY(' + (-14 + 14 * entra).toFixed(2) + 'deg) scale(' + (.86 + .14 * entra - (i === N - 1 ? .05 * suave(local) : 0)).toFixed(3) + ')';
      var fin = i === N - 1 ? suave(local * 1.4) : 0;
      nivel.style.transform = 'scaleX(' + (.62 + .38 * fin).toFixed(3) + ')';
      logro.style.opacity = fin.toFixed(3);
      logro.style.transform = 'translate3d(0,' + (40 - 40 * rebote(fin)).toFixed(1) + 'px,' + (220 * fin).toFixed(1) + 'px) scale(' + (.75 + .25 * rebote(fin)).toFixed(3) + ')';
    });
  });

  /* Suscripciones: sección a pantalla completa. Las tarjetas empiezan desordenadas (temblando), se ordenan alrededor de Rumbo con
     líneas finas, el contador va sumando y al final Rumbo se queda quieto con un destello. El ratón suma su propio desplazamiento con «translate». */
  $$('[data-subs]').forEach(function (s) {
    var mesa = s.querySelector('.subs__mesa'), cartas = $$('.subs__cobro', mesa), rumbo = s.querySelector('.subs__rumbo'), lineas = $$('line', mesa);
    var contador = s.querySelector('.subs__contador'), plantilla = contador ? contador.dataset.plantilla : '', ejemplo = contador ? contador.querySelector('small').outerHTML : '';
    /* En el móvil: tocar una tarjeta la levanta y enseña su bocadillo */
    cartas.forEach(function (k) { k.addEventListener('click', function () { cartas.forEach(function (o) { if (o !== k) o.classList.remove('tocada'); }); k.classList.toggle('tocada'); }); });
    if (quieto || !window.matchMedia('(min-width: 901px)').matches) return;
    s.classList.add('subs--vivo');
    var inicio = [[-.27, -.34, -7], [.24, -.36, 5], [-.04, -.14, -3], [.28, .02, 8], [-.29, .12, 4], [.08, .3, -6], [-.16, .38, 3]];
    var euros = cartas.map(function (k) { return +k.dataset.euros || 0; });
    var w = 1, h = 1, ax = .4, ay = .36, pos = cartas.map(function () { return [0, 0]; }), ultimo = -1;
    escena(s, s, function (p) {
      /* Pausas: 0–12 % desordenadas, 12–82 % se ordenan, 82–100 % Rumbo quieto */
      var q = limitar((p - .12) / .7);
      s.classList.toggle('subs--temblor', q < .02);
      s.classList.toggle('subs--junto', q > .985);
      var n = 0, total = 0;
      for (var i = 0; i < cartas.length; i++) {
        var a = (i / cartas.length) * Math.PI * 2 - Math.PI / 2, ex = Math.cos(a) * ax, ey = Math.sin(a) * ay;
        var tt = suave(limitar(q * 1.3 - i * .045));
        if (tt > .5) { n++; total += euros[i]; }
        var x = (inicio[i][0] + (ex - inicio[i][0]) * tt) * w, y = (inicio[i][1] + (ey - inicio[i][1]) * tt) * h;
        pos[i] = [x, y];
        cartas[i].style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) translate(-50%,-50%) scale(' + (1 - .16 * tt).toFixed(3) + ')';
        cartas[i].style.opacity = (1 - .28 * tt).toFixed(3);
        var l = lineas[i];
        if (l) { l.setAttribute('x1', w / 2); l.setAttribute('y1', h / 2); l.setAttribute('x2', (w / 2 + x).toFixed(1)); l.setAttribute('y2', (h / 2 + y).toFixed(1)); l.style.strokeDashoffset = (1 - suave(limitar((q - .45) * 2.2))).toFixed(3); }
      }
      if (contador && n !== ultimo) { ultimo = n; contador.innerHTML = (n === 1 ? contador.dataset.uno : plantilla).replace('N', n).replace('T', total) + ' ' + ejemplo; contador.classList.toggle('subs__contador--cero', n === 0); }
      var r = rebote(limitar((q - .35) * 2));
      rumbo.style.opacity = limitar((q - .3) * 3).toFixed(3);
      rumbo.style.transform = 'translate(-50%,-50%) scale(' + (.7 + .3 * r).toFixed(3) + ')';
    }, {
      alMedir: function () {
        w = mesa.offsetWidth; h = mesa.offsetHeight;
        ax = Math.max(.2, (w / 2 - cartas[0].offsetWidth * .42 - 4) / w); ay = Math.max(.2, (h / 2 - cartas[0].offsetHeight * .42 - 8) / h);
      }
    });
    /* Ratón: parallax hacia el cursor (las de delante se mueven más) y un imán suave que separa las tarjetas cercanas */
    var raton = null, mov = cartas.map(function () { return [0, 0]; }), vivoR = false, caja = null;
    var bucleR = function () {
      var sigue = false;
      for (var i = 0; i < cartas.length; i++) {
        var tx = 0, ty = 0;
        if (raton) {
          var prof = .4 + (i % 3) * .3;
          tx = raton[0] * 14 * prof; ty = raton[1] * 10 * prof;
          var dx = w / 2 + pos[i][0] - raton[2], dy = h / 2 + pos[i][1] - raton[3], d = Math.sqrt(dx * dx + dy * dy) || 1;
          if (d < 170) { var f = (1 - d / 170) * 18; tx += dx / d * f; ty += dy / d * f; }
        }
        mov[i][0] += (tx - mov[i][0]) * .12; mov[i][1] += (ty - mov[i][1]) * .12;
        if (Math.abs(tx - mov[i][0]) > .05 || Math.abs(ty - mov[i][1]) > .05) sigue = true;
        cartas[i].style.translate = mov[i][0].toFixed(1) + 'px ' + mov[i][1].toFixed(1) + 'px';
      }
      if (sigue) requestAnimationFrame(bucleR); else vivoR = false;
    };
    var moverR = function () { if (!vivoR) { vivoR = true; requestAnimationFrame(bucleR); } };
    mesa.addEventListener('pointerenter', function () { caja = mesa.getBoundingClientRect(); });
    mesa.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (!caja) caja = mesa.getBoundingClientRect();
      var px = e.clientX - caja.left, py = e.clientY - caja.top;
      raton = [px / caja.width * 2 - 1, py / caja.height * 2 - 1, px, py]; moverR();
    });
    mesa.addEventListener('pointerleave', function () { raton = null; caja = null; moverR(); });
    window.addEventListener('scroll', function () { caja = null; }, { passive: true });
  });
  /* Mi camino como historia: Arranque se abre, aparece el personaje (en gris, «en pijama»), se personaliza con el panel al lado,
     salta de parada en parada encendiendo logros y nivel, y al final salta el logro en 3D. Todo sale de un solo progreso suavizado. */
  $$('[data-micamino]').forEach(function (c) {
    var q = function (k) { return c.querySelector('[data-mc="' + k + '"]'); };
    var pasos = $$('.mc__paso', c), paradas = $$('[data-parada]', c), puntos = $$('.mc__logros i', c), chips = $$('[data-chip]', c), accs = $$('[data-acc]', c);
    var yo = q('yo'), ruta = q('ruta'), panel = q('panel'), final = q('final'), nivel = q('nivel'), barra = q('barra'), camara = q('camara');
    var app = c.querySelector('.mc__app'), fondo = c.querySelector('.mc__ruta-fondo');
    var fijo = function () {
      c.classList.add('mc--quieto');
      pasos.forEach(function (s) { s.classList.add('hecho'); }); paradas.forEach(function (s) { s.classList.add('hecha', 'abierta'); });
      puntos.concat(chips, accs).forEach(function (e) { e.classList.add('ver'); });
    };
    if (quieto || !window.matchMedia('(min-width: 901px)').matches || !fondo.getTotalLength) return fijo();
    c.classList.add('mc--vivo');
    var L = fondo.getTotalLength(), largos = [], aw = 1, ah = 1, yw = 1, yh = 1, activo = -1, nv = -1;
    /* Largo de la ruta en cada parada (una vez): el punto de la ruta más cercano a cada parada */
    paradas.forEach(function (pa) {
      var x = +pa.dataset.x, y = +pa.dataset.y, mejor = 0, d = 1e9;
      for (var s = 0; s <= 300; s++) { var l = L * s / 300, pt = fondo.getPointAtLength(l), dd = (pt.x - x) * (pt.x - x) + (pt.y - y) * (pt.y - y); if (dd < d) { d = dd; mejor = l; } }
      largos.push(mejor);
    });
    var tramo = function (p, a, b) { return limitar((p - a) / (b - a)); };
    escena(c, c.querySelector('.mc__pista'), function (p) {
      /* Texto de cada tramo */
      var cortes = [.14, .28, .46, .84], i = 0;
      while (i < cortes.length && p >= cortes[i]) i++;
      if (i !== activo) { activo = i; pasos.forEach(function (s, k) { s.classList.toggle('activo', k === i); s.classList.toggle('hecho', k < i); }); }
      /* 1) Arranque se abre y enciende sus logros */
      paradas[0].classList.toggle('abierta', p > .02);
      puntos.forEach(function (pt, k) { pt.classList.toggle('ver', p > .05 + k * .03); });
      /* 4) Viaje: de Arranque a las siguientes paradas, con un saltito en cada tramo */
      var l = largos[0], salto = 0, llegadas = 0;
      var viajes = [[.48, .58], [.6, .7], [.72, .8], [.84, .9]];
      for (var v = 0; v < viajes.length; v++) {
        var t = tramo(p, viajes[v][0], viajes[v][1]);
        if (t > 0) { l = largos[v] + (largos[v + 1] - largos[v]) * suave(t); salto = Math.sin(Math.PI * t) * 18; }
        if (t >= 1) llegadas = v + 1;
      }
      paradas.forEach(function (pa, k) { pa.classList.toggle('hecha', k <= llegadas && p > .14); });
      chips.forEach(function (ch, k) { ch.classList.toggle('ver', llegadas >= k + 1); });
      ruta.style.strokeDashoffset = (1 - l / L).toFixed(4);
      /* 2) El personaje aparece con un rebote; 3) gana color y accesorios */
      var pt = fondo.getPointAtLength(l), entra = rebote(tramo(p, .14, .2));
      var px = pt.x / 400 * aw - yw / 2, py = pt.y / 560 * ah - yh * .8 - salto;
      yo.style.transform = 'translate3d(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px,0) scale(' + (.4 + .6 * entra).toFixed(3) + ')';
      yo.style.opacity = limitar((p - .14) * 30).toFixed(3);
      var color = suave(tramo(p, .3, .36));
      yo.style.setProperty('--gris', (1 - color).toFixed(3));
      yo.classList.toggle('mc__yo--pijama', p > .15 && p < .3);
      accs.forEach(function (a, k) { a.classList.toggle('ver', p > .3 + k * .03); });
      var pv = tramo(p, .28, .32) * (1 - tramo(p, .46, .5));
      panel.style.opacity = pv.toFixed(3);
      panel.style.transform = 'translate3d(' + (40 * (1 - suave(pv))).toFixed(1) + 'px,0,0) rotateY(' + (-10 * (1 - suave(pv))).toFixed(2) + 'deg)';
      /* Nivel y barra */
      var n = Math.min(7, 1 + (p > .2 ? 1 : 0) + (p > .4 ? 1 : 0) + llegadas);
      if (n !== nv) { nv = n; nivel.textContent = n; }
      barra.style.transform = 'scaleX(' + (n / 10).toFixed(2) + ')';
      /* 5) Logro final en 3D */
      var r = rebote(tramo(p, .9, .97));
      final.style.opacity = limitar((p - .9) * 20).toFixed(3);
      final.style.transform = 'translate3d(-50%,' + (60 - 60 * r).toFixed(1) + 'px,' + (200 * r).toFixed(1) + 'px) scale(' + (.7 + .3 * r).toFixed(3) + ')';
      camara.style.transform = 'rotateX(' + (10 - 6 * suave(p)).toFixed(2) + 'deg) rotateY(' + (-8 + 8 * suave(p)).toFixed(2) + 'deg)';
      c.style.setProperty('--p', p.toFixed(4));
    }, { alMedir: function () { aw = app.offsetWidth; ah = app.offsetHeight; yw = yo.offsetWidth; yh = yo.offsetHeight; } });
  });
})();


/* Logos oficiales de cada marca dentro del texto (norma de la marca Rumbo, 3/11/2026).
   Cuando un texto nombra una marca o plataforma, se pone su logo justo delante, a la altura de la letra (clase .mi), una vez por frase.
   Fuera: avisos legales, notas al pie, tablas comparativas, botones (ya lo llevan en el tema) y formularios. */
(function () {
  var base = document.body && document.body.getAttribute('data-marcas');
  if (!base) return;
  var MARCAS = [['Google Sheets', 'sheets'], ['Google Ads', 'googleads'], ['Lemon Squeezy', 'lemonsqueezy'], ['Windows', 'windows'], ['Claude', 'claude'], ['Anthropic', 'anthropic', 1], ['Shopify', 'shopify'], ['TikTok', 'tiktok'], ['Instagram', 'instagram', 1], ['Facebook', 'facebook'], ['WhatsApp', 'whatsapp'], ['YouTube', 'youtube'], ['Excel', 'excel'], ['Meta', 'meta'], ['Mac', 'apple', 1]];
  var FUERA = '.nota,.pie,.prosa,.tabla,.comparativa__nota,.demo,.cinta,.r-ins,.mi,.boton,button,a.team,.team,input,textarea,select,label,script,style,svg,.idiomas,.sugerencia,.ficha,.r-tag,[aria-hidden="true"],.casos__nota,.tarifa__aviso,.planes__impuestos,.zonas,.isla,.menu,.cine__etiqueta,.smart,.subs__mesa,.mc__escena,.como-claude__pasos,title';
  var raiz = document.getElementById('contenido') || document.body;
  var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT), nodos = [], n;
  while ((n = w.nextNode())) {
    if (!/\S/.test(n.nodeValue) || !n.parentElement || n.parentElement.closest(FUERA)) continue;
    for (var i = 0; i < MARCAS.length; i++) { if (new RegExp('(^|[^\\wÀ-ÿ])' + MARCAS[i][0] + '(?![\\wÀ-ÿ])').test(n.nodeValue)) { nodos.push(n); break; } }
  }
  nodos.forEach(function (t) {
    var texto = t.nodeValue, frag = document.createDocumentFragment(), usados = {}, pos = 0;
    var re = new RegExp('(^|[^\\wÀ-ÿ])(' + MARCAS.map(function (m) { return m[0]; }).join('|') + ')(?![\\wÀ-ÿ])', 'g'), m;
    while ((m = re.exec(texto))) {
      var nombre = m[2], marca = null;
      for (var j = 0; j < MARCAS.length; j++) if (MARCAS[j][0] === nombre) marca = MARCAS[j];
      if (!marca || usados[marca[1]]) continue;
      usados[marca[1]] = 1;
      var ini = m.index + m[1].length;
      frag.appendChild(document.createTextNode(texto.slice(pos, ini)));
      var s = document.createElement('span'); s.className = 'mi';
      var img = new Image(); img.src = base + 'marca-' + marca[1] + '.svg'; img.alt = ''; img.width = 16; img.height = 16; img.decoding = 'async';
      if (marca[2]) img.setAttribute('data-negro', '');
      s.appendChild(img); s.appendChild(document.createTextNode(nombre));
      frag.appendChild(s); pos = ini + nombre.length;
    }
    if (pos === 0) return;
    frag.appendChild(document.createTextNode(texto.slice(pos)));
    t.parentNode.replaceChild(frag, t);
  });
})();
